import FeedItem from '@app/components/FeedItem'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'

import { actionCreators as feedItemsActionCreators } from '@app/components/FeedItem/modules/feedItems'

interface IComponentRouterProps {
  id: string
}

export default class FeedItemViewPage extends React.Component<
  RouteComponentProps<IComponentRouterProps> & typeof feedItemsActionCreators,
  {}
> {
  public constructor(props: any) {
    super(props)

    this.props.loadFeedItem(this.props.match.params.id)
  }

  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.props.loadFeedItem(nextProps.match.params.id)
    }
  }

  public render() {
    return (
      <DocumentTitle title='Feed Item Details'>
        <div className='container mt-3'>
          <div className='flex-grow-1'>
            <FeedItem
              key={this.props.match.params.id}
              feedItemId={this.props.match.params.id}
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}
